// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconDownloadPath = 'm5.29 9.707 4 4a1 1 0 0 0 1.415 0l4-4-1.415-1.414-2.293 2.293V2h-2v8.586L6.705 8.293 5.29 9.707Zm9.36 6.903 3.56-4.629 1.585 1.22-3.56 4.628A3.017 3.017 0 0 1 13.857 19H6.146a3.017 3.017 0 0 1-2.376-1.168L.21 13.216l1.584-1.221 3.56 4.615c.188.245.484.39.792.39h7.711c.309 0 .605-.146.793-.39Z';
var IconDownload = baseIcon('IconDownload', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconDownloadPath
});
export default IconDownload;
//# sourceMappingURL=index.js.map